import { useEffect, useState } from 'react';
import styles from './Toast.module.scss';
import Button from '../Button/ButtonComponent';
import { ReactSVG } from 'react-svg';
import { dataResources } from '@portal-internet/core';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

export default function ToastComponent() {
    const [loaded, setLoaded] = useState(false);
    const { toastText, setToastText } = useRedl();

    const onClick = () => {
        setToastText('');
    };

    useEffect(() => {
        if (toastText) {
            setLoaded(true);
            setTimeout(() => setToastText(''), 3000);
        } else {
            if (loaded) {
                setLoaded(false);
            }
        }
    }, [loaded, toastText, setToastText]);

    //no s'ha de pintar si no tenim error per no tapar altres botons
    return toastText ? (
        <ol className={styles.redlToastList}>
            <li className={`${styles.redlToast} ${toastText ? styles.redlToastOpen : loaded ? styles.redlToastClosed : null}`}>
                <div className={styles.redlToastButton}>
                    <Button variant='tertiary' size='sm' onClick={onClick}>
                        <ReactSVG src={basePath + '/_resources/REDL/icons/x.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                    </Button>
                </div>
                <div className={styles.redlToastText}>
                    <p>{toastText}</p>
                </div>
            </li>
        </ol>
    ) : null;
}
